import React from 'react'

function Feature() {

    let feData = [
        {
            "img": `${require('../assets/images/f2.png')}`,
            "name": 'Pedidos online'
        },
        {
            "img": `${require('../assets/images/f3.png')}`,
            "name": 'Ahorra dinero'
        },
        {
            "img": `${require('../assets/images/f4.png')}`,
            "name": 'Promociones'
        },
        {
            "img": `${require('../assets/images/f5.png')}`,
            "name": 'Venta Feliz'
        },
        {
            "img": `${require('../assets/images/f6.png')}`,
            "name": '24/7 Support'
        },
    ]

    return(
       
        <section className="feature">

            {feData.map((f)=>{
                return(
                    <div className="fe-box">
                        <img src={f.img} alt="" />
                        <h6>{f.name}</h6>
                    </div>
                )
            })}
           

        </section>

    )
}

export default Feature;
